import { render } from "./EditDomainForm.vue?vue&type=template&id=494f01b4"
import script from "./EditDomainForm.vue?vue&type=script&lang=js"
export * from "./EditDomainForm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__